module.exports = __webpack_public_path__ + "img/warm-artichoke-dip.89c3092f.jpg";